module.exports = __webpack_public_path__ + "img/fig01.c4c536f2.jpg";